import AssetsGridRowWrapper from 'components/AssetsGrid/components/AssetsGridRowWrapper';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const AssetsGridHeader: FunctionComponent<Props> = ({ children, ref, testId = TEST_ID }) => (
    <AssetsGridRowWrapper ref={ref} testId={testId}>
        {children}
    </AssetsGridRowWrapper>
);

export default AssetsGridHeader;
